import DataTable from 'react-data-table-component';
import {customStyles} from "../../utils/data/essential";
import { useFetchData } from '../../hooks/useFetchData';
const UserRoles = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  // Fetch user roles data
  const url = `users/roles`;
  const { data, isLoading } = useFetchData(["fetch-users-role"], url,true,user);
  if (isLoading)
    return (
      <div
        className='d-flex justify-content-center'
        style={{ marginTop: "15%" }}
      >
        <h5>Loading...</h5>
      </div>
    );
  
  const columns = [
    {
      name: "Role Id",
      cell: (row) => row["id"],
    },
    {
      name: "Role Name",
      cell: (row) => row["name"],
    },
  ];
  return (
    <div>
      <div className='table-responsive datatables dataValidation-Wrap thead-primary pr-3 pl-3 mr-2'>
        <DataTable
          columns={columns}
          data={data}
          responsive={true}
          customStyles={customStyles}
          pagination
          highlightOnHover
          striped
          noHeader
        />
      </div>
    </div>
  );
}

export default UserRoles